import HighPriority from './HighPriority';

export default HighPriority;
